import React from "react";

import { MainLeftTitle } from "../../_uiComponents/WrapperComponents";
import DataUpload from "./DataUpload";


function DataTableWrapper() {
     return (
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="Data Upload Center"/>
               <DataUpload/>
          </div>
     );
}

export default DataTableWrapper;